import { defineMessages } from 'react-intl';

export default defineMessages({
  submit: 'Zastosuj',
});
